import styles from './error.module.scss';
import IconWarning from './icon-warning.png';

const Error = () => {
  return (
    <div className={styles.siteWidth}>
      <div className={styles.errorPanel}>
        <img src={IconWarning} alt="Warning" />

        <h2>Sorry, there has been an error</h2>
        <p>Please try again.</p>
      </div>
    </div>
  );
};

export default Error;
